export default "__VITE_ASSET__cLS1xd2v__"